import { Routes, CanDeactivateFn } from '@angular/router';
import { CaseDetailsComponent } from './components/case-details/case-details.component';
import { DictationComponent } from './components/dictation/dictation.component';

export const CASE_DETAILS_ROUTES: Routes = [
  {
    path: ':patientKey',
    component: CaseDetailsComponent,
    children: [
      { path: '', redirectTo: 'demographics', pathMatch: 'full' },
      {
        path: 'demographics',
        loadComponent: () =>
          import('./components/demographics/demographics.component').then((m) => m.DemographicsComponent),
      },
      {
        path: 'appointments',
        loadComponent: () =>
          import('./components/appointments/appointments.component').then((m) => m.AppointmentsComponent),
      },
      {
        path: 'documents',
        loadComponent: () => import('./components/documents/documents.component').then((m) => m.DocumentsComponent),
      },
      {
        path: 'tasks',
        loadComponent: () => import('./components/tasks/case-tasks.component').then((m) => m.CaseTasksComponent),
      },
      {
        path: 'dictation',
        loadComponent: () => import('./components/dictation/dictation.component').then((m) => m.DictationComponent),
        canDeactivate: [(component: DictationComponent) => component.canDeactivate()],
      },
      {
        path: 'dictation/:dictationId/transcription',
        loadComponent: () =>
          import('./components/dictation-transcription/dictation-transcription.component').then(
            (m) => m.DictationTranscriptionComponent
          ),
      },
      {
        path: 'notes',
        loadComponent: () => import('./components/notes/notes.component').then((m) => m.NotesComponent),
      },
    ],
  },
];
